import { formatStarRating } from '../utils/reviewsFormatters';

export const StarDisplay = ({ rating }: { rating: number }) => (
  <span className="text-amber-400 font-bold tracking-wide">
    {formatStarRating(Math.round(rating))}
  </span>
);